import { useRouter } from 'next/router';

export const useAppRoute = () => {
    const router = useRouter();

    const isPolli = router.pathname === '/polli';
    const isHomePage = router.pathname === '/' || isPolli;

    return {
        isPolli,
        isHomePage,
    };
};
